/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getVacancy = /* GraphQL */ `
  query GetVacancy($id: ID!) {
    getVacancy(id: $id) {
      id
      title
      location
      employment
      summary
      description
      hidden
      reactions {
        items {
          id
          vacancyID
          name
          email
          phoneNumber
          message
          cvFileKey
        }
        nextToken
      }
    }
  }
`
export const listVacancies = /* GraphQL */ `
  query ListVacancies($filter: ModelVacancyFilterInput, $limit: Int, $nextToken: String) {
    listVacancies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        location
        employment
        summary
        description
        hidden
        reactions {
          items {
            id
            name
            email
            phoneNumber
            message
            cvFileKey
          }
          nextToken
        }
      }
      nextToken
    }
  }
`
export const getVacancyReaction = /* GraphQL */ `
  query GetVacancyReaction($id: ID!) {
    getVacancyReaction(id: $id) {
      id
      vacancyID
      name
      email
      phoneNumber
      message
      cvFileKey
    }
  }
`
export const listVacancyReactions = /* GraphQL */ `
  query ListVacancyReactions(
    $filter: ModelVacancyReactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVacancyReactions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        vacancyID
        name
        email
        phoneNumber
        message
        cvFileKey
      }
      nextToken
    }
  }
`
